import { useState } from "react";
import { motion } from "framer-motion";
import { Navigation } from "../components/landing/Navigation";
import { Hero } from "../components/landing/Header";
import { Story } from "../components/landing/Story";
import { ProductsSection } from "../components/landing/ProductsSection";
import { CampaignOrganizerSection } from "../components/landing/CampaignOrganizerSection";
import { DonateModal } from "../components/landing/DonateModal";
import { DonorFeed } from "../components/landing/DonorFeed";
import { FAQ } from "../components/landing/FAQ";
import { Footer } from "../components/landing/Footer";

const Landing = () => {
  const [isDonateModalOpen, setIsDonateModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Navigation onDonateClick={() => setIsDonateModalOpen(true)} />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <Hero />
        
        <div>
          <section id="mission">
            <Story />
          </section>
          
          <section className="bg-muted/20">
            <ProductsSection />
          </section>
          
          <section className="bg-muted/20">
            <DonorFeed />
          </section>

          <section>
            <CampaignOrganizerSection />
          </section>
          

          <section>
            <FAQ />
          </section>
          
          <Footer />
        </div>
      </motion.div>

      <DonateModal 
        isOpen={isDonateModalOpen}
        onClose={() => setIsDonateModalOpen(false)}
      />
    </div>
  );
};

export default Landing;
